<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <PromotionPopup :data-set="dataSet" @close="close" @open="open" @open-agent-popup="openAgentPopup"
            @open-p-w-a-popup="openPWAPopup"  />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <PromotionPopupTwo :data-set="dataSet" @close="close" @open="open" @open-agent-popup="openAgentPopup"
            @open-p-w-a-popup="openPWAPopup"  />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <PromotionPopupThree :data-set="dataSet" ref="promotionRef" @open-agent-popup="openAgentPopup"
            @open-p-w-a-popup="openPWAPopup"  />
    </div>
</template>


<script setup lang="ts">
import { ref, computed } from 'vue'
import { useActivityStore } from '@/stores/activity';
import PromotionPopup from '@/themes/themeOne/promotion/promotionPopup.vue';
import PromotionPopupTwo from '@/themes/themeTwo/promotion/promotionPopup.vue';
import PromotionPopupThree from '@/themes/themeThree/promotion/promotionPage.vue';
import { PromotionData } from './supporrtScript';
import { useThemeStore } from '@/stores/theme';
import { useUserStore } from '@/stores/user';
import { useI18n } from 'vue-i18n';
const userStore = useUserStore()
const themeStore = useThemeStore()
const activityStore = useActivityStore()
const promotionRef = ref()
const { t } = useI18n()
const show = ref(false)
const promotionList = computed<any>(() => activityStore.activityList)
    const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
    const isPwaClaimed = computed(() => userStore?.PWAConvertData?.isPwaClaimed)
    const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)

const dataSet = computed<PromotionData>(() => ({
    show: show.value,
    promotionList: promotionList.value
}))

const emits = defineEmits(['handleClose', "openAgent", "openPWA"])
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
    emits('handleClose')
}
const openAgentPopup = () => {
    emits("openAgent")
}

const openPWAPopup = () => {
    if(themeStore.themeIndex === 3) {
        if (canRecievedRewards.value === 1) {
        if (isPwaClaimed.value === 1) {
            promotionRef.value.pwaStatusPoupOpen(t('activityStatus.completed'))
        } else {
            promotionRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
        }
    } else if (isOpen.value === 0) {
        promotionRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
    } else {
        promotionRef.value.pwaPoupOpen()
    }
    } else {
        emits("openPWA")
    }
    
}

defineExpose({
    open,
    close
})



</script>